import { createActions, handleActions } from 'redux-actions';
import Notifications from 'react-notification-system-redux';

const actions = createActions({
    EXPORTS: {
        FETCHING: reportType => ({ reportType }),
        FETCHED: downloadUrl => ({ downloadUrl }),
    },
});

export const REPORT_TYPES = {
    CONTACT_REQUESTS: 'CONTACT_REQUESTS',
    CONTACT_REGION_REQUESTS: 'CONTACT_REGION_REQUESTS',
};

// Each report type maps to a Laravel API export endpoint. These endpoints read
// the live application database and return a { downloadUrl } to a generated
// CSV. This replaces the standalone AWS export Lambda, which queried the old
// pre-migration database directly and so never saw newly created requests.
const REPORT_ENDPOINTS = {
    [REPORT_TYPES.CONTACT_REQUESTS]: '/propertycontactrequests/download',
    [REPORT_TYPES.CONTACT_REGION_REQUESTS]: '/contactrequests/download',
};

const initialState = {
    error: null,
    fetching: false,
};

export default handleActions(
    {
        [actions.exports.fetching]: (state, action) =>
            Object.assign({}, initialState, {
                fetching: true,
            }),

        [actions.exports.fetched]: {
            next: (state, action) => {
                return Object.assign({}, initialState, {
                    fetching: false,
                });
            },
            throw: (state, action) => {
                return Object.assign({}, initialState, {
                    fetching: false,
                    error: true,
                });
            },
        },
    },
    initialState
);

export const getExportDownload = reportType => {
    return (dispatch, getState, api) => {
        const endpoint = REPORT_ENDPOINTS[reportType];

        if (!endpoint) {
            return Promise.resolve();
        }

        dispatch(actions.exports.fetching(reportType));

        return api
            .get(endpoint)
            .then(response => {
                const downloadUrl = response.data && response.data.downloadUrl;

                if (downloadUrl) {
                    dispatch(actions.exports.fetched(downloadUrl));
                    window.location.href = downloadUrl;
                    return;
                }

                // 200 but no file produced (e.g. nothing to export, or S3 not
                // configured). Passing an Error routes to the reducer's `throw`
                // handler, clearing the fetching flag.
                dispatch(
                    actions.exports.fetched(new Error('No export available'))
                );
                dispatch(
                    Notifications.warning({
                        title: 'Nothing to export',
                        message: 'No records were available to export.',
                        position: 'tc',
                        autoDismiss: 5,
                    })
                );
            })
            .catch(err => {
                dispatch(actions.exports.fetched(err));
                dispatch(
                    Notifications.error({
                        title: 'Export failed',
                        message:
                            'An error occurred whilst generating the export. Please try again.',
                        position: 'tc',
                        autoDismiss: 5,
                    })
                );
            });
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/exports.js